define('controller/step/BookingRescheduleStepManager',['require','__original__/BookingRescheduleStepManager','controller/step/datetime/SlotsDateTimeStep','controller/step/datetime/FlexibleDateTimeStep'],function (require) {

    var Parent = require('__original__/BookingRescheduleStepManager');

    var SlotsDateTimeStep = require('controller/step/datetime/SlotsDateTimeStep');
    var FlexibleDateTimeStep = require('controller/step/datetime/FlexibleDateTimeStep');

    return Parent.extend({

        _getTimelineStepInstance: function (stepParams) {
            switch (Config.getInstance().getTimelineType()) {
                case Config.TIMELINE_SLOTS:
                case Config.TIMELINE_GRID_WEEKLY:
                    return new SlotsDateTimeStep(stepParams);
                case Config.TIMELINE_FLEXIBLE:
                    return new FlexibleDateTimeStep(stepParams);
                default:
                    return new SlotsDateTimeStep(stepParams);
            }
        },

    });

});
